import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Sizes } from "../../commons/types/core-types";

interface ScreenResizeState {
  mobileView: boolean;
  smallImageCropper: boolean;
  stepperFormModalSize: Sizes | "2xl" | "mdl";
}

const initialState: ScreenResizeState = {
  mobileView: false,
  smallImageCropper: false,
  stepperFormModalSize: "lg",
};

export const ScreenResizeSlice = createSlice({
  name: "ScreenResizeSlice",
  initialState: initialState,
  reducers: {
    setMobileView: (state, action: PayloadAction<boolean>) => {
      state.mobileView = action.payload;
    },
    setSmallImageCropper: (state, action: PayloadAction<boolean>) => {
      state.smallImageCropper = action.payload;
    },
    setStepperFormModalSize: (state, action: PayloadAction<Sizes | "2xl" | "mdl">) => {
      state.stepperFormModalSize = action.payload;
    },
    cleanUpMobileView(state) {
      state.mobileView = false;
    },
    cleanUpSmallImageCropper(state) {
      state.smallImageCropper = false;
    },
    cleanUpStepperFormModalSize(state) {
      state.stepperFormModalSize = "lg";
    },
  },
});

export const {
  setMobileView,
  setStepperFormModalSize,
  setSmallImageCropper,
  cleanUpMobileView,
  cleanUpSmallImageCropper,
  cleanUpStepperFormModalSize,
} = ScreenResizeSlice.actions;

export default ScreenResizeSlice.reducer;
